import React from 'react';
import LoaderImg from './Loader.gif';

function Loader() {
    return (
        <div className='d-flex justify-content-center'>
<img src={LoaderImg} alt="loading..."  width="50px" height="50px"/>
        </div>
    );
}

export default Loader;
